import { render, staticRenderFns } from "./Kusama.vue?vue&type=template&id=7ccc7626&scoped=true&"
import script from "./Kusama.vue?vue&type=script&lang=js&"
export * from "./Kusama.vue?vue&type=script&lang=js&"
import style0 from "./Kusama.vue?vue&type=style&index=0&id=7ccc7626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccc7626",
  null
  
)

export default component.exports